import { FC, PropsWithChildren, useMemo, useState } from "react";
import styled from "styled-components";

import {
  useLayoutViewportHeight,
  usePageScrollPositionMemory,
} from "@ryde/redux";
import { DATA_E2E_KEY, IStyledAttributes, ScrollAreaEnum } from "@ryde/shared";

const TableItemWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "table-item-wrapper",
  className: "middle_scrollbar",
})`
  width: 100%;
  overflow: auto;
`;

export const TableItemWrapper: FC<PropsWithChildren> = ({ children }) => {
  const viewportHeight = useLayoutViewportHeight();
  const [scrollElement, setScrollElement] = useState<HTMLDivElement | null>(
    null,
  );

  usePageScrollPositionMemory({
    element: scrollElement,
    area: ScrollAreaEnum.Grid,
  });

  const wrapperStyle = useMemo(
    () => ({
      height: viewportHeight,
    }),
    [viewportHeight],
  );

  return (
    <TableItemWrapperStyled ref={setScrollElement} style={wrapperStyle}>
      {children}
    </TableItemWrapperStyled>
  );
};
